import { gql } from 'urql';

const GetCustomerApplicationStatus = gql`
  query GetCustomerApplicationStatus {
    applications {
      __typename
      ... on BankApplication {
        __typename
        id
        bankApplicationStatus
        productSelections
      }
    }
  }
`;

export default GetCustomerApplicationStatus;
